import React, {useEffect} from 'react';
import {
    Box,
    chakra,
    Flex,
    SimpleGrid,
    Stat,
    StatLabel,
    StatNumber,
    useColorModeValue,
  } from '@chakra-ui/react';
  import { BsListCheck } from 'react-icons/bs';
  import { BiMoney} from 'react-icons/bi';
  import { useSelector } from 'react-redux';
  

  function StatsCard(props) {
    const { title, stat, icon } = props;
    return (    
      <Stat
        px={{ base: 2, md: 4 }}
        py={'5'}
        shadow={'xl'}
        border={'1px solid'}
        borderColor={useColorModeValue('gray.800', 'gray.500')}
        rounded={'lg'}>
        <Flex justifyContent={'space-between'}>
          <Box pl={{ base: 2, md: 4 }}>
            <StatLabel fontWeight={'medium'} istruncated="true">
              {title}
            </StatLabel>
            <StatNumber fontSize={'2xl'} fontWeight={'medium'}>
              {stat}
            </StatNumber>
          </Box>
          <Box
            my={'auto'}
            color={useColorModeValue('gray.800', 'gray.200')}
            alignContent={'center'}>
            {icon}
          </Box>
        </Flex>
      </Stat>
    );
  }
  
  export default function ExpenseListView() {
    const list = useSelector(state => state.expense.list)
    const budget = useSelector((state) => state.expense.budget)
    const totalExpenseAmount = list.reduce(function (acc, obj) { return acc + Math.round(obj.price); }, 0);
    const totalBudgetAmount = budget.reduce(function (acc, obj) { return acc + Math.round(obj.amount); }, 0);

    const amountRemaining = Math.round(totalBudgetAmount - totalExpenseAmount)

    return (
      <Box maxW="7xl" mx={'auto'} pt={5} px={{ base: 2, sm: 12, md: 17 }}>
        <chakra.h1
          textAlign={'left'}
          fontSize={'xl'}
          py={10}
          fontWeight={'bold'}>
          Expense Details
        </chakra.h1>
        <SimpleGrid columns={{ base: 1, md: 3 }} spacing={{ base: 5, lg: 8 }}>
          <StatsCard
            title={'No. of Expenses'}
            stat={list.length}
            icon={<BsListCheck size={'3em'} />}
          />
          <StatsCard
            title={'Total Prices'}
            stat={totalExpenseAmount}
            icon={<BiMoney size={'3em'} />}
          />
          <StatsCard
            title={'Amount Remaining'}
            stat={amountRemaining.toString()}
            icon={<BiMoney size={'3em'} />}
          />
        </SimpleGrid>
      </Box>
    );
  }